export enum RosterStatus {
    NEW = 1,
    IN_PROGRESS = 2,
    COMPLETED = 3,
    CANCELLED = 4,
    ACTIVE = 5,
    UNPAID = 6
}

export enum StopStatus {
    PENDING = 1,
    IN_TRANSIT = 2,
    SUCCESSFUL = 3,
    FAILED = 4,
    SKIPPED = 5,
    CANCELLED = 6,
    PICKED_UP = 7,
    MISSING_ITEM = 8,
    FAILED_PICKUP = 9
}

export enum ShiftType {
    DEDI = 1,
    FLEXI = 2,
    SHIFT = 1,
    JOBS = 2
}

export enum StopType {
    DELIVERY = 1,
    PICKUP = 2,
    DRIVER_MONITORING = 3
}

export enum ServiceType {
    MACHSHIP = 5,
    DEDI_TAILGATE = 6,
    FLEXI_TAILGATE = 7
}

export enum ServiceCategory {
    SERVICE = 1,
    SHIPMENT = 2
}

export enum OptimisationType {
    ONEWAY = 1,
    ROUNDTRIP = 2
}


export enum SuccessfulDeliveryStatus {
    DELIVERED,
    SIGNATURE_REQUIRED,
    ATL,
}
export const SuccessfulDeliveryStatusMapping = {
    [SuccessfulDeliveryStatus.DELIVERED]: { id: 1, name: 'Successfully Delivered' },
    [SuccessfulDeliveryStatus.SIGNATURE_REQUIRED]: { id: 7, name: 'Signature Required' },
    [SuccessfulDeliveryStatus.ATL]: { id: 2, name: 'Authority To Leave' }
};

export enum FailedDeliveryStatus {
    REJECTED,
    CARD_LEFT,
    NO_RECEIVER,
    WRONG_ADDRESS,
}

export const FailedDeliveryStatusMapping = {
    [FailedDeliveryStatus.REJECTED]: { id: 24, name: 'Rejected'},
    [FailedDeliveryStatus.CARD_LEFT]: { id: 25, name: 'Unsuccessful (Card Left)'},
    [FailedDeliveryStatus.NO_RECEIVER]: { id: 3, name: 'Receiver cannot be contacted' },
    [FailedDeliveryStatus.WRONG_ADDRESS]: { id: 4, name: 'Wrong Address' }
};

// Rejected has two substatus ids depending on shift_type_id: FailedDeliveryStatusMapping's id (24)
// is for shift_type_id 2 (job), 31 is for shift_type_id 1 (shift). Use this for any id-based
// "is this substatus Rejected" check instead of comparing against a single id.
export const REJECTED_SUBSTATUS_IDS = [FailedDeliveryStatusMapping[FailedDeliveryStatus.REJECTED].id, 31];

export enum SuccessfulPickuptatus {
    PICKED_UP,  
}

export const SuccessfulPickupStatusMapping = {
    [SuccessfulPickuptatus.PICKED_UP]: { id: 20, name: 'Successfully Picked' }
};

export enum FailedPickupStatus {
    NO_SENDER,
    WRONG_ADDRESS
}

export const FailedPickupStatusMapping = {
    [FailedPickupStatus.NO_SENDER]: { id: 21, name: 'Sender cannot be contacted' },
    [FailedPickupStatus.WRONG_ADDRESS]: { id: 22, name: 'Wrong Address' },
};

export enum PaidType {
    HOURLY = 1,
    SERVICE = 2

}

export enum DriverStatus {
    APPROVED = 1,
    REGISTRATION_STARTED = 2,
    REGISTRATION_COMPLETED = 3,
    BACKGROUND_CHECK_INPROGRESS = 4,
    DEACTIVATED = 5,
    INCOMPLETE_ONBOARDING = 6
}